<template>
  <div>
    <page-main
      :height="height"
      :loading="loading"
      :tableData="tableData"
      :type="type"
      :tablePage="page"
      ref="tableMain"
    >
      <page-header ref="header" slot="header" @query="getData" />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
  </div>
</template>
<script>
import PageMain from './main.vue'
import PageHeader from './header.vue'
import BaseTable from '@/mixins/base-table'
export default {
  components: { PageMain, PageHeader },
  mixins: [BaseTable],

  props: {
    height: { type: Number, default: 300 },
    productLine: { type: String, default: '' },
    categoryCode: { type: String, default: '' },
    type: { type: String, default: 'radio' },
  },
  data() {
    return {
      usePage: true,
      loading: false,
      tableData: [],
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .masterFormulaListApi({
          productLine: this.productLine,
          categoryCode: this.categoryCode,
          formulaStatusList: ['Y'],
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    choiceData() {
      return this.$refs.tableMain.choiceData()
    },
  },
}
</script>
